module.exports = "//static.hsappstatic.net/notifications/static-1.7274/img/notifications-badge.png"